/* eslint-disable react/prop-types */
/* eslint-disable no-alert */
/* eslint-disable no-promise-executor-return */
/* eslint-disable no-return-await */
/* eslint-disable react/no-unknown-property */
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { Stack, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { styled } from '@mui/material/styles'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { useSnackbar } from 'notistack'
import React, { useEffect, useRef, useState } from 'react'
import { useCookies } from 'react-cookie'
import axios from '../axios'
import SearchBox from '../components/SearchBox'
import { awsConfig } from '../config'
import Styles from '../style/theme'
import { toastMessageStyle } from '../style/toastMessage'

const PageTitle = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '32px',
  color: Styles.Color.PrimaryDarkBlue,
}))

const StyledDatePicker = styled(DatePicker)(() => ({
  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    width: '300px',
    maxHeight: '48px',
    paddingRight: '0',
  },
  '& .MuiInputBase-input.MuiOutlinedInput-input': {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    color: Styles.Color.SecondaryGray4,
    height: '24px',
    width: '238px',
    margin: '12px 0px 12px 16px',
    padding: '0',
  },
  '& .MuiInputBase-input.MuiOutlinedInput-input::placeholder': {
    opacity: '1',
  },
  '& .MuiInputAdornment-root': {
    marginLeft: '10px',
  },
  '& .MuiButtonBase-root.MuiIconButton-root': {
    padding: '0',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${Styles.Color.SecondaryGray2}`,
    borderRadius: '8px',
  },
  '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: Styles.Color.SecondaryRed,
  },
  '& .MuiFormHelperText-root.Mui-error': {
    color: Styles.Color.SecondaryRed,
    margin: '8px 0px',
    width: '301px',
    height: ' 24px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
  },
}))

const TableCellTh = styled(TableCell)(() => ({
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '24px',
  color: Styles.Color.SecondaryGray4,
  backgroundColor: Styles.Color.SecondaryGray1,
}))

const TableCellTd = styled(TableCell)(() => ({
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  color: Styles.Color.PrimaryBlack,
  height: '72px',
}))

function CostExplorerReports() {
  const [cookies] = useCookies()
  const token = cookies?.token
  const { enqueueSnackbar } = useSnackbar()
  const refDate = useRef(null)
  const [isLoading, setIsLoading] = useState(true)
  const [keyword, setKeyword] = useState('')
  const [reports, setReports] = useState('')

  const handleSearchInputChanged = (e) => {
    setKeyword(e.target.value)
  }

  const clearKeyword = () => {
    setKeyword('')
  }

  const getCostExplorerFilter = async () => {
    try {
      const url = `${awsConfig.apiEndpoint}/?mode=getCostExplorerFilter&openIdToken=${token}&timestamp=${new Date().getTime()}`
      const res = await axios.get(url)
      setReports(JSON.parse(res.data))
    } catch (e) {
      console.log('getCostExplorerFilter error', e)
    } finally {
      setIsLoading(false)
    }
  }

  const handleDownloadButtonClick = async (reportName) => {
    if (!refDate.current) return

    try {
      setIsLoading(true)
      const url = `${awsConfig.apiEndpoint}/?mode=queryPreGenerateCostExplorerReport&year=${refDate.current.year()}&month=${refDate.current.month() + 1}&report_name=${reportName}&openIdToken=${token}`
      const res = await axios.get(url)
      window.location.href = res.data
    } catch (e) {
      if (e.response.status === 404) {
        enqueueSnackbar('File Not Found', {
          variant: 'error',
          sx: toastMessageStyle,
        })
      } else {
        console.log('error', e.response.data)
      }
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getCostExplorerFilter()
  }, [])

  return (
    <Stack mt="32px" mx="24px" flex="1">
      {isLoading && (
        <Stack alignItems="center" justifyContent="center" sx={{ position: 'absolute', width: '100%', height: '100%' }}>
          <CircularProgress />
        </Stack>
      )}
      <PageTitle>Cost Explorer Reports</PageTitle>
      <Stack direction="row" mt={3.5}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <StyledDatePicker
            onChange={(newValue) => {
              refDate.current = newValue
            }}
            label="Date"
            openTo="month"
            views={['year', 'month']}
          />
        </LocalizationProvider>
        <Stack ml={3}>
          <SearchBox placeholder="Search by Name" height="48px" width="320px" value={keyword} onChange={handleSearchInputChanged} clearKeyword={clearKeyword} />
        </Stack>
      </Stack>
      <Stack mt={2}>
        <TableContainer
          sx={{
            border: `1px solid ${Styles.Color.SecondaryGray2}`,
            borderRadius: '12px',
          }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCellTh>Name</TableCellTh>
                <TableCellTh>Actions</TableCellTh>
              </TableRow>
            </TableHead>
            <TableBody>
              {reports &&
                reports
                  .filter((r) => r.report_name.toLowerCase().indexOf(keyword.toLowerCase()) > -1)
                  .map((r) => (
                    <TableRow key={r.report_name}>
                      <TableCellTd component="th" scope="row">
                        {r.report_name}
                      </TableCellTd>
                      <TableCellTd width="240px">
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                          sx={{
                            color: Styles.Color.PrimaryBlue,
                            cursor: 'pointer',
                            width: '150px',
                          }}
                          onClick={() => handleDownloadButtonClick(r.report_name)}>
                          <FileDownloadOutlinedIcon />
                          <Typography mt="4px" ml="15px" sx={{ fontWeight: 700 }}>
                            Download
                          </Typography>
                        </Stack>
                      </TableCellTd>
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Stack>
  )
}

export default CostExplorerReports
